import React from "react";
import { Divider } from "../Controls";
import PageActions from "./PageActions";
import terms from "../../assets/strings/terms.js";
import privacy from "../../assets/strings/privacy.js";

import "./styles.less";

const LegalPage = () => (
  <div className="text-page terms">
    <p className="page-intro" style={{ textAlign: "center" }}>
      {terms.h3}
    </p>
    <h1>{terms.title}</h1>
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: terms.html }}
    />
    <h1>{privacy.title}</h1>
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: privacy.html }}
    />
    <PageActions />
  </div>
);

export default LegalPage;



// WEBPACK FOOTER //
// ./components/Pages/Legal.js